import ExpandableSection from "../component/_expandableSection";

document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.js-section-dashboard-block');

    sections.forEach((section) => {
        new ExpandableSection(
            '.js-section-key-benefits-block-benefit',
            '.js-section-key-benefits-block-title-wrapper',
            '.js-section-key-benefits-block-benefit-description',
            '.js-section-key-benefits-block-chevron',
            true,
            false,
            false,
            false,
        );
    });
});
